"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomMonthWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var moment = require("moment");
var FalconQuestionWidgetBase_1 = require("./FalconQuestionWidgetBase");
var journey_model_1 = require("@athena-portal/journey-model");
var CustomMonthWidget = /** @class */ (function (_super) {
    __extends(CustomMonthWidget, _super);
    function CustomMonthWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.componentDidUpdate = function (prevProps, prevState) {
            var interactionDateString = _this.bindFromField(_this.interactionField);
            if (interactionDateString && prevState.dateString !== interactionDateString) {
                var interactionDate = _this.strToDate(interactionDateString);
                if (interactionDate !== undefined) {
                    _this.setState({
                        month: interactionDate.format("MM"),
                        year: interactionDate.format("YYYY"),
                        dateString: interactionDateString
                    });
                }
            }
        };
        _this.updateInteractionField = function (dateString) {
            _this.props.onStateChange(_this.interactionField, dateString);
        };
        _this.renderInputField = function () {
            var showLabels = _this.getSetting("showLabels", false);
            return ((0, jsx_runtime_1.jsxs)("div", { id: _this.props.question.name, className: "customDate-container", children: [(0, jsx_runtime_1.jsxs)("div", { children: [showLabels && (0, jsx_runtime_1.jsxs)("label", { className: "font-weight-light", htmlFor: "".concat(_this.props.question.name, "-month"), children: ["Month", (0, jsx_runtime_1.jsx)("br", {})] }), (0, jsx_runtime_1.jsx)("input", { id: "".concat(_this.props.question.name, "-month"), className: "form-control ".concat(_this.getInputValidationClass(), " customDate-month"), "aria-label": "Month input field", type: "text", placeholder: "MM", maxLength: 2, readOnly: _this.isReadOnly(), value: _this.state.month, onClick: _this.executeNativeEvent, onFocus: _this.executeNativeEvent, onChange: _this.handleMonthChange, onBlur: _this.handleOnBlurEvent })] }), (0, jsx_runtime_1.jsxs)("div", { children: [showLabels && (0, jsx_runtime_1.jsxs)("label", { className: "font-weight-light", htmlFor: "".concat(_this.props.question.name, "-year"), children: ["Year", (0, jsx_runtime_1.jsx)("br", {})] }), (0, jsx_runtime_1.jsx)("input", { id: "".concat(_this.props.question.name, "-year"), className: "form-control ".concat(_this.getInputValidationClass(), " customDate-year"), "aria-label": "Year input field", type: "text", placeholder: "YYYY", maxLength: 4, readOnly: _this.isReadOnly(), value: _this.state.year, onClick: _this.executeNativeEvent, onFocus: _this.executeNativeEvent, onChange: _this.handleYearChange, onBlur: _this.handleOnBlurEvent })] })] }));
        };
        _this.handleMonthChange = function (event) {
            event.persist();
            _this.setState({
                month: event.target.value
            }, function () {
                _this.handleChange(event);
            });
        };
        _this.handleYearChange = function (event) {
            event.persist();
            _this.setState({
                year: event.target.value
            }, function () { return _this.handleChange(event); });
        };
        _this.handleChange = function (event) {
            var _a = _this.state, month = _a.month, year = _a.year;
            var formattedMonth = "";
            if (month) {
                formattedMonth = month.length > 1 ? month : "0".concat(month);
            }
            var dateString = year || formattedMonth ? "".concat(year, "-").concat(formattedMonth, "-01") : "";
            _this.setState({
                dateString: dateString
            }, function () {
                var interactionDate = _this.strToDate(dateString);
                if (interactionDate === null || interactionDate === void 0 ? void 0 : interactionDate.isValid()) {
                    // Only update interaction field if string represents a valid date, otherwise there will be a JSON error
                    // parsing the string
                    _this.updateInteractionField(dateString);
                }
                else {
                    // Interaction date must be cleared, so that question does not pass mandatory validation on submit
                    _this.updateInteractionField("");
                }
                _this.validateInternal(_this.state.dateString);
                _this.executeNativeEvent(event);
            });
        };
        _this.handleOnBlurEvent = function (event) {
            _this.validateInternal(_this.state.dateString);
            _this.executeNativeEvent(event);
        };
        _this.interactionField = _this.props.question.interactionField;
        var interactionDateString = _this.bindFromField(_this.interactionField);
        var interactionDate = _this.strToDate(interactionDateString);
        if (interactionDate) {
            _this.state = {
                month: interactionDate.format("MM"),
                year: interactionDate.format("YYYY"),
                dateString: interactionDateString
            };
        }
        else {
            _this.state = {
                month: "",
                year: "",
                dateString: ""
            };
        }
        return _this;
    }
    CustomMonthWidget.prototype.strToDate = function (interactionDateString) {
        return interactionDateString ? moment(interactionDateString, moment.ISO_8601) : undefined;
    };
    CustomMonthWidget = __decorate([
        (0, journey_model_1.settings)([
            { name: "showLabels", type: journey_model_1.TypeDescriptions.Boolean }
        ])
        /*
         * Caveat: the date Question using this widget must be validated as mandatory in the form.
         * Otherwise there would be a problem with this scenario:
         * When interaction date holds a previous saved valid date, and user enters invalid input,
         * we clear the interaction field, but user would be able to click Next and pass form
         * validation if field is not mandatory.
         *
         * The previous solution was storing invalid dates as strings in interaction object, and it was causing problems with
         * JSONification of those dates when calling changelogRecorder.
         */
        ,
        __metadata("design:paramtypes", [Object])
    ], CustomMonthWidget);
    return CustomMonthWidget;
}(FalconQuestionWidgetBase_1.FalconQuestionWidgetBase));
exports.CustomMonthWidget = CustomMonthWidget;
//# sourceMappingURL=CustomMonthWidget.js.map